import { useContext } from '../context'

export const useEditorContext = () => {
  return useContext()
}
